import { render, staticRenderFns } from "./GoogleBackupTable.vue?vue&type=template&id=05717b85&scoped=true&"
import script from "./GoogleBackupTable.vue?vue&type=script&lang=js&"
export * from "./GoogleBackupTable.vue?vue&type=script&lang=js&"
import style0 from "./GoogleBackupTable.vue?vue&type=style&index=0&id=05717b85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05717b85",
  null
  
)

export default component.exports